import { AxiosResponse } from 'axios';
import { LoginResponseData } from '@interfaces/Login.interface';

/**
 * Handles control tower redirect logic
 * @param response - The login response
 * @returns boolean indicating if redirect was handled
 */
export const handleControlTowerRedirect = (
  response?: AxiosResponse<LoginResponseData>
) => {
  const controltowerUrl = import.meta.env.VITE_CONTROLTOWER_URL;
  if (response?.status === 201 && response?.data?.root_token) {
    window.location.href = `${controltowerUrl}/?token=${encodeURIComponent(
      response.data.root_token
    )}`;
    return true;
  }
  return false;
};
